module.exports = __webpack_public_path__ + "static/media/prelude-to-crack.a5695e02.png";